<div class="titleblock">
  <h3 class="title1level">Parti processo telematico</h3>
  <p>
    <a href="javascript:void(0)" (click)="changeSelectMode()">
      {{ selectMsg }} <span [class]="'glyphicon '+((isSelectMode) ? 'glyphicon-save' : 'glyphicon-check')"></span>
    </a>
  </p>
</div>
  <div class="container_dati_generali">

    <div class="row  min-margin">
      <div class="col-sm-3 ">
        <button class="btn btn-primary" aria-label="Aggiorna Dati" (click)="updatePct()">Aggiorna dati <span
            class="glyphicon glyphicon-refresh"></span></button>
      </div>

      <div class="col-sm-5 col-md-offset-4 ">
        <div class="row" *ngIf="model">
          <p>
            <span class="pda-last-update-label">Data ultimo aggiornamento: </span>
            <span class="pda-last-update-value"> {{ model.dataUltimoAggiornamento | date: "dd/MM/YYYY HH:mm" }} </span>
          </p>
        </div>
      </div>
    </div>

    <div *ngIf="model && model.parti?.length > 0">
      <div *ngFor="let partyType of partyTypes">
        <div *ngIf="hasPartiesOfType(partyType.filterName)" class="panel panel-default min-margin">
          <div class="panel-heading">
            <!-- <h4 class="panel-title" style="position:relative;"></h4> -->
              <div class="row">
                <div class="col-sm-1">
                  <div *ngIf="isSelectMode" class="form-group col-sm-12 listcheckbox">
                    <div style="display: flex;">
                      <input class="pct-party-checkbox" type="checkbox" id="select-parte-lbl-{{partyType.filterName}}"
                        [checked]="isPartyTypeSelected(partyType.filterName)" (click)="onClickPartyTypeSelected(partyType.filterName)">
                      <label for="select-parte-lbl-{{partyType.filterName}}">
                        <small class="sr-only">Seleziona categoria</small>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-sm-9">
                  <b>{{partyType.accordionLabel}}</b>
                </div>
                <div class="col-sm-2">
                  <a [ngClass]="accordionToggleClassHandler(partyType.filterName)" href="javascrip:void(0)" data-toggle="collapse" (click)="toggleCollapse(partyType.filterName)">
                    <small class="sr-only">Apri o chiudi {{partyType.accordionLabel}}</small>
                  </a>
                </div>
              </div>
              

          </div>
          <div [id]="'COLLAPSE'+partyType.filterName" [ngStyle]="{'height': collapseState[partyType.filterName] ? 'auto' : '0', 'overflow': 'hidden', 'transition': 'height 0.35s ease'}" [ngClass]="accordionBodyClassHandler(partyType.filterName)" style="height:auto!important;">
            <div class="panel-body" styel="padding:0">
              <div>
                <table class="table-striped table aggiunta_classificazione min-margin ">
                  <caption class="sr-only">Tabella Parti</caption>
                  <tr>
                    <th>Parte</th>
                    <th *ngIf="isControparte(partyType)">Avvocato</th>
                    <th *ngIf="isSelectMode">Seleziona</th>
                  </tr>
                  <tr class="borded" *ngFor="let parte of model.parti | filter: 'tipoParte' : partyType.filterName ">
                    <td>
                      <strong>
                        {{parte.nome }} {{parte.cognome}} ( {{ parte.codiceFiscale }} )
                      </strong>
                    </td>
                    <td *ngIf="isControparte(partyType)">
                      <strong> Avv. {{parte.legale}} ( {{parte.cfLegale}} )</strong>
                    </td>
                    <td *ngIf="isSelectMode">
                      <div class="form-group col-sm-12 listcheckbox">
                        <div style="display: flex;">
                          <input class="pct-party-checkbox" type="checkbox" id="select-parte-lbl-{{parte.idPartePct}}"
                            [checked]="isPartySelected(parte)" (click)="onClickSelected(parte)">
                          <label for="select-parte-lbl-{{parte.idPartePct}}">
                            <small class="sr-only">Seleziona parte</small>
                          </label>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>

    </div>

  </div>

<app-pda-section-nodata *ngIf="!model || model.parti?.length <= 0"></app-pda-section-nodata>
